
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "searchControl", "cancelControl"]

  // Removes all Asset Select Buttons when one is pressed to prevent 
  // multiple controls being open together
  search(e) {
    e.preventDefault();
    this.searchControlTargets.forEach(e => e.style.display="none");
  }
  cancelSearch(e) {
    e.preventDefault();
    this.searchControlTargets.forEach(e => e.style.display="inherit");
  }

}
